import { createAppSlice } from 'utils/createAppSlice'
import { defaultInitialState } from 'utils/defaultInitialState.ts'
import { MinstroyJobsSliceInitialState } from 'components/Resources/Jobs/NestedPages/MinstroyJobs/MinstroyJobs.types'


const minStroyJobsInitialState: MinstroyJobsSliceInitialState = { ...defaultInitialState }

export const minStroyJobsSlice = createAppSlice<MinstroyJobsSliceInitialState>('minstroyJobs', minStroyJobsInitialState)

export default minStroyJobsSlice.reducer